import { takeLatest, call, put } from 'redux-saga/effects'

import admin, { ResponseRequestCourses } from 'api/requestCourses/ListAdmin'
import {
  REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN,
  Actions,
} from '../../actions/requestOutsideCourses.action'
import { RequestOutsideCoursesGetListAction } from 'store/actions/requestOutsideCourses.action'

const pattern = REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN

function* listRequestCoursesAdminEffectSaga({
  payload,
}: RequestOutsideCoursesGetListAction) {
  try {
    const data: ResponseRequestCourses = yield call(admin, payload?.q)
    yield put(Actions.setListAdminSuccess(data))
  } catch (error) {
    console.error('error: ', error)
    yield put(Actions.setLoading(false))
  }
}

export function* listRequestCoursesAdminWatcherSaga() {
  yield takeLatest(pattern, listRequestCoursesAdminEffectSaga)
}
